<template> 
    <div style="background:#fff; margin-top:1px;margin-left:1px;overflow-y:auto; "> 
        <div style="height:70vh;overflow-y:auto;">
            <div style="line-height:30px;display:flex;background:#808695;font-weight:600;font-size:14px;color:white;width:100%">
                <div style="width:300px;padding-left:4px ">字段名称(剔勾=显示)</div> 
                <div style="width:50px;padding-left:4px ">冻结</div> 
                <div style="width:60px;padding-left:4px ">宽度</div> 
            </div>
            <draggable :options="{ filter: '.no-drag', animation: 200,preventOnFilter: false }" v-model="localArr"  item-key="FLDNO" class="draggable" @start="drag=true" @end="drag=false">
                <div style="line-height:30px;height:30px;display:flex;" v-for="(item ) in localArr" :key="item.FLDNO" :class="{ 'no-drag': (item.FLDNO === 'rownum'||item.FLDNO=='oper') }" >
                    <div style="display:flex">
                        <div style="width:300px;padding-left:4px; ">
                            <el-checkbox true-label="Y" :disabled="item.FLDNO=='rownum'||item.FLDNO=='oper'" false-label="N" v-model="item['VISFLAG']" >{{item['FLDNM']}}</el-checkbox>
                        </div>
                        <div style="width:50px;  ">
                            <el-checkbox true-label="Y" :disabled="item.FLDNO=='rownum'||item.FLDNO=='oper'" false-label="N" v-model="item['ISFIX']" style="width:50px"  ></el-checkbox>
                        </div>
                        <div style="width:60px;text-align:center; ">
                            <el-input size="mini" readonly v-model="item['COLWIDTH']" style="width:60px"> </el-input>
                        </div>
                    </div>
                </div>
            </draggable>
        </div>
        <div style="height:35px;line-height:30px;border-top:2px solid #ccc;padding-top:2px; ">
            <span style="float:right">
                <el-button type="info" @click="btnExit" size="small"  icon="iconfont icon-chexiao_icon">  恢复默认</el-button>
                <el-button   @click="btnOk" size="small" type="primary" style="margin-left:50px;" icon="iconfont icon-baocun"  > 保存设置 </el-button> 
            </span>
        </div> 
 
    </div>
</template>
<script>
import draggable from 'vuedraggable' 
export default {
    props: {
  
        colArr:{
            type:Array,
        } ,
 
    },
    name: 'easytable_set',
    data () {
        return {
 
            // 在 data 中初始化副本
            localArr: JSON.parse(JSON.stringify(this.colArr)),
            v_corpid:this.$cookies.get('v_corpid'),
      
            v_username:this.$cookies.get('v_telno'), //api 请求用户
            v_password:this.$cookies.get('v_pwd') ,//api 请求密码
            v_url: 'auth/getTableRecMany', //api请求路径
        }
    },
    created () {
        
    },
    components: {
        draggable,
    },
    mounted () {  
     
    } ,
    watch: {
        colArr(newVal) {
            this.localArr = JSON.parse(JSON.stringify(newVal))
        },
        localArr: {
            handler(newVal) {
                this.$emit('update:colArr', newVal)
            },
            deep: true
        }
    },
    methods: {  
 
        btnExit(){
            this.$emit('child-exit' )
        },
        //
        btnOk(){
           // console.log(JSON.stringify(this.localArr))
            this.$emit('child-sure', this.localArr)
        },
 
    }
}
 
</script>
<style scoped lang="less" >
    .no-drag {
        cursor: not-allowed;
        opacity: 0.6;
        background-color: #dfdcdc;
    }
    .draggable {
        cursor: move; /* 显示可拖动光标 */
        padding: 10px;
        margin-bottom: 5px;
    }
    .item-width2  {
        width: 97%;
    } 
</style>
 
